<template>
  <div
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    data-backdrop="static"
    class="modal fade"
    id="office_create"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-blg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" @click="close" type="button">
            <i class="iconfont icon-close"></i>
          </button>
          <h5 class="modal-title" id="myModalLabel">
            新建{{office.type}}
            <span v-if="!office.preview_path">（正在创建，请稍等...）</span>
          </h5>
        </div>
        <div class="modal-body">
          <iframe :src="office.preview_path" frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "createOffice",
  props: {
    office: {
      type: Object
    }
  },
  data() {
    return {
      preview_path: ""
    };
  },
  methods: {
    close() {
      this.$emit("reloadInfo");
      $("#office_create").modal("hide");
    }
  }
};
</script>

<style scoped>
.modal-header {
  padding: 10px;
  height: 40px;
  background: #f8f8f8;
}
.modal-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal-body {
  padding: 0;
  width: 100%;
  height: calc(100% - 40px);
}
.modal-blg {
  margin-top: 20px;
  width: 100%;
  height: 100%;
}
.office_create,
.modal-content {
  width: 100%;
  height: 100%;
}
.modal-body iframe {
  width: 100%;
  height: 100%;
}
.iconfont {
  font-size: 14px;
}
</style>